export default __webpack_public_path__ + "static/media/Good Transport.f6551099.jpg";